import { Tabs, TabsProps } from "antd";

interface IProps extends TabsProps {}

export default function TabsUI(props: IProps) {
  return <Tabs {...props}>{props.children}</Tabs>;
}
